import * as _ from 'lodash'
import React, { useState } from 'react';
import keyboardUtil from 'Scripts/keyboardUtils';
import { useJobCostItemDragDrop } from 'Scripts/draggableJobCostLineItem';
import globalRelay from 'Scripts/globalRelay';
import valueFilters from 'Scripts/valueFilters';
import { FractionInput } from 'Scripts/components/sharedComponents';

const KEY_DOWN_CODES = [13];

export function JobCostApplianceRowComponent(props) {
	const globalConfig = globalRelay.config!;
	const { classNames = [], workAreas, buttonClass, applianceSpec, draggable, dropLineItem, alwaysValidate, buttonHandler, updateModel } = props;
	const [shouldValidate, setShouldValidate] = useState(alwaysValidate);
	const [{isDragging, dragSourceRef, dragPreviewRef, dropItem, dropTargetRef, rowRef}] = useJobCostItemDragDrop({ 
		item: applianceSpec,
		handleDrop: (dragItem, dropItem) => dropLineItem(dragItem.key, dropItem.key) 
	});

	function handleUpdate (path, autoSave, e) {
		e.preventDefault();

		let newVal;
		if (path === 'note') {
			newVal = (autoSave) ? valueFilters.trim(e.target.value) : e.target.value;
		}
		else {
			newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;
		}

		updateModel(model => {
			model.setAt(path, newVal);
		}, { autoSave: autoSave });
	}
	
	function validate (property?) {
		if (property && (property === 'workAreaKey' || property === 'name')) {
			const result = !applianceSpec.test(property);
		
			return result;
		}
		return true;
	}

	function validateAllRequired() {
		return (!applianceSpec.test('workAreaKey') && !applianceSpec.test('name'));
	}

	function handleButtonClick (e) {
		e.preventDefault();
		
		const valid = validateAllRequired();

		if (!valid) {
			setShouldValidate(true)
		}
		else {
			// this assumes that the add handler succeeds
			setShouldValidate(alwaysValidate);
		}

		buttonHandler(valid, e);
	}


	// Define the work area options list
	const workAreaOptions:JSX.Element[] = [];

	workAreaOptions.push(<option key="unknown_workarea" value="">Select</option>);
	_.forEach(workAreas, workArea => {
		workAreaOptions.push(<option key={workArea.key} value={workArea.key}>{workArea.name}</option>);
	});

	const disableItemEntry = (applianceSpec.name === undefined) ? 'disabled' : '';

	// Configure the default appliances
	const applianceOptions:JSX.Element[] = [];

	_.forEach(globalConfig.jobCostSettings.specifications.defaultAppliances, a => {
		applianceOptions.push(<option key={a} value={a}>{a}</option>);
	});

	return (
		<tr ref={ rowRef } className={ classNames.join(' ') }>
			<td />
			<td>
				<select className={!validate('workAreaKey') ? 'required' : ''} placeholder="Select" value={applianceSpec.viewValue('workAreaKey')} onChange={e => handleUpdate('workAreaKey', true, e)}>
					{ workAreaOptions }
				</select>
			</td>
			<td>
				<input type="text" className="dataList" list={'spec_' + applianceSpec.key} 
					placeholder="Enter or Select" value={applianceSpec.viewValue('name')} 
					onChange={e => handleUpdate('name', false, e)} 
					onBlur={e => handleUpdate('name', true, e)}
					onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
				<datalist id={'spec_' + applianceSpec.key}>
					{ applianceOptions }
				</datalist>
			</td>
			<td>
				<input type="text" disabled={!!disableItemEntry} className={disableItemEntry} placeholder="Enter" 
					autoCapitalize="" autoCorrect="off" value={applianceSpec.viewValue('value')} 
					onChange={e => handleUpdate('value', false, e)} 
					onBlur={e => handleUpdate('value', true, e)}
					onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))} />
			</td>
			<td className={'lwh'}>
				<FractionInput className={disableItemEntry} placeholder="W" 
					value={applianceSpec.applianceSize.viewValue('width')} 
					onChange={e => handleUpdate('applianceSize/width', false, e)} 
					onBlur={e => handleUpdate('applianceSize/width', true, e)} 
					onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
				<FractionInput className={disableItemEntry} placeholder="H" 
					value={applianceSpec.applianceSize.viewValue('height')} 
					onChange={e => handleUpdate('applianceSize/height', false, e)} 
					onBlur={e => handleUpdate('applianceSize/height', true, e)} 
					onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
				<FractionInput className={disableItemEntry} placeholder="D" 
					value={applianceSpec.applianceSize.viewValue('depth')} 
					onChange={e => handleUpdate('applianceSize/depth', false, e)} 
					onBlur={e => handleUpdate('applianceSize/depth', true, e)} 
					onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>

			</td>
			<td className={'lwh'}>
				<FractionInput className={disableItemEntry} placeholder="W" 
					value={applianceSpec.openingSize.viewValue('width')} 
					onChange={e => handleUpdate('openingSize/width', false, e)} 
					onBlur={e => handleUpdate('openingSize/width', true, e)} 
					onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
				<FractionInput className={disableItemEntry} placeholder="H" 
					value={applianceSpec.openingSize.viewValue('height')} 
					onChange={e => handleUpdate('openingSize/height', false, e)} 
					onBlur={e => handleUpdate('openingSize/height', true, e)}
					onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))} />
				<FractionInput className={disableItemEntry} placeholder="D" 
					value={applianceSpec.openingSize.viewValue('depth')} 
					onChange={e => handleUpdate('openingSize/depth', false, e)} 
					onBlur={e => handleUpdate('openingSize/depth', true, e)}
					onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))} />
			</td>
			<td><textarea className={ `lineItemDescription ${disableItemEntry}` } placeholder="Enter" value={ applianceSpec.viewValue('note') } onChange={e => handleUpdate('note', false, e)} onBlur={e => handleUpdate('note', true, e)} /></td>
			<td><button className={buttonClass} onClick={handleButtonClick}><span /></button></td>
			<td />
		</tr>
	);
}